<template>
  <Page>
    <SidePageColumn side="left">
      <div class="pl-5 r-5">
        <div class="h2 grey--text mt-2 mb-0">Category Alphabets</div>
        <v-btn
          small
          width="100"
          tile
          color="primary"
          :disabled="is_loading"
          v-for="(alpha, index) in alphabets"
          :key="index"
          :outlined="alpha != selected_alpha"
          @click="go_to_section(alpha)"
        >
          <v-icon left>mdi-eye</v-icon>
          {{ alpha }}
        </v-btn>
      </div>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="[]"
        title="Business Categories"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>

      <div
        class="componet-has-nav-bar white pt-5"
        style="min-height: 700px"
        v-if="is_loading == false"
      >
        <v-row no-gutters v-for="(group, index) in categories" :key="index">
          <v-col cols="12">
            <CardedSectionHeader
              icon="mdi-group"
              :label="index.toUpperCase()"
              :id="'categories_alpah_section_' + index"
            ></CardedSectionHeader>
          </v-col>
          <v-col
            no-gutters
            cols="3"
            v-for="(category, index) in group"
            :key="index"
          >
            <CategoryTile 
              :category="category"
              :belongings="belongings"
              :sub_categories="sub_categories"
              @on-click="select_category"
              >
            </CategoryTile>
          </v-col>
        </v-row>
      </div>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import CategoryTile from "./../../components/CategoryTile";


import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "Categories",
  components: {
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
    CategoryTile
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "categories",
    page_info: page_info,
    categories: [],
    belongings: {},
    sub_categories: {},
    alphabets: [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ],
    selected_alpha: "a",
    // image_link: require("../../assets/lady_2.png"),
  }),
  methods: {
    load_categories() {
      this.$emit("on-show-loader");
      ServerClient.Categories.fetch_categories_page(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          var grouping = {};
          for (var index = 0; index < this.alphabets.length; index++) {
            var ch = this.alphabets[index];
            grouping[ch] = [];
          }
          for (var index = 0; index < res.categories.length; index++) {
            var cat = res.categories[index];
            var name = cat.name.toLowerCase();
            var ch = name[0];
            grouping[ch].push(cat);
          }
          this.categories = grouping;
          this.belongings = res.belongings;
          this.sub_categories = res.sub_categories;
          var vm = this;
          setTimeout(() => {
            vm.go_to_section("a");
          }, 1000);
        },
        (errors) => {
          console.log(
            "Errors loading categories on public categories page: ",
            errors
          );
          this.$emit("on-hide-loader");
        }
      );
    },
    go_to_section(alpha) {
      this.selected_alpha = alpha;
      this.scroll_to_secton(alpha);
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    select_category(category) {
      this.$router.push("/categories/" + category.id);
    },
    scroll_to_secton(alpha) {
      try {
        var options = {
          offset: 50,
          duration: 1000,
          easing: "easeInOutCubic",
        };
        this.$vuetify.goTo("#categories_alpah_section_" + alpha, options);
      } catch (error) {
        console.log("Error scrolling to section on categories page ", error);
      }
    },
  },
  mounted() {
    this.load_categories();
  },
};
</script>